import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import ProfileCard from "views/console/team-managements/components/ProfileCard";
import { LucideCake } from "lucide-react";
import {
	getUpcomingBirthday
} from "../../../../redux/overview/overviewState";



const BirthdaysTable = ({
	recordList,
	getList
}) => {

useEffect(() => {
	getList();
}, [getList]);

return (
	<HeaderComponent
		title="Upcoming Birthdays"
		description="Celebrate your team members' special days"
		bgcolor="bg-purple-50/30"
		icon={<LucideCake size={20}/>}
		colorTheme="flat-purple"
		shadow="shadow-sm"
		border="border-b"
	>
		<div className="pt-10 flex-1">
			<div className= "relative pr-1 h-[500px] overflow-y-auto">
				<div className="space-y-3">
					{recordList?.data?.map((item) => (
						<ProfileCard 
							key={item.emp_id}        
							recordData={item}    
						/>
					))}
				</div>
			</div>
		</div>
		
	</HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.overview.teamUpcomingBirthday?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getList: (filters) => dispatch(getUpcomingBirthday(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BirthdaysTable);
